// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-69402bb5]{width:1200px;margin:0 auto;margin-top:50px}", ""]);
// Exports
module.exports = exports;
